var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.fullNameTitle,
            visible: _vm.dialogVisible,
            width: "1000px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "attendanceKid",
              attrs: {
                "label-width": "120px",
                model: _vm.attendanceKidFormModel,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { gutter: 20 },
                },
                _vm._l(_vm.shiftList, function (shift) {
                  return _c(
                    "el-col",
                    { key: shift.shiftId, attrs: { span: 24 } },
                    [
                      shift.id != null
                        ? _c("div", { staticClass: "shift-card" }, [
                            _c("div", { staticClass: "shift-header" }, [
                              _c("strong", [_vm._v(_vm._s(shift.shiftName))]),
                            ]),
                            _c("div", { staticClass: "shift-row" }, [
                              _c(
                                "div",
                                { staticClass: "shift-col shift-media" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "shift-media-title" },
                                    [_vm._v("Ảnh đến")]
                                  ),
                                  _c("image-uploader", {
                                    attrs: {
                                      preview: shift.checkinImageUrl,
                                      placeholder: "Tải ảnh đến",
                                      updateAttendance: _vm.updateAttendance,
                                    },
                                    model: {
                                      value: shift.checkinImage,
                                      callback: function ($$v) {
                                        _vm.$set(shift, "checkinImage", $$v)
                                      },
                                      expression: "shift.checkinImage",
                                    },
                                  }),
                                  _c("div", { staticClass: "shift-time" }, [
                                    _vm._v("\n                  Giờ đến: "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatTime")(
                                            shift.checkinTime
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "shift-col shift-media" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "shift-media-title" },
                                    [_vm._v("Ảnh về")]
                                  ),
                                  _c("image-uploader", {
                                    attrs: {
                                      preview: shift.checkoutImageUrl,
                                      placeholder: "Tải ảnh về",
                                      disabled: !_vm.updateAttendance,
                                    },
                                    model: {
                                      value: shift.checkoutImage,
                                      callback: function ($$v) {
                                        _vm.$set(shift, "checkoutImage", $$v)
                                      },
                                      expression: "shift.checkoutImage",
                                    },
                                  }),
                                  _c("div", { staticClass: "shift-time" }, [
                                    _vm._v("\n                  Giờ về: "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatTime")(
                                            shift.checkoutTime
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "shift-col shift-note" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "shift-media-title" },
                                    [_vm._v("Ghi chú")]
                                  ),
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      rows: 3,
                                      placeholder: "Nhập ghi chú cho ca",
                                      disabled: !_vm.updateAttendance,
                                    },
                                    model: {
                                      value: shift.note,
                                      callback: function ($$v) {
                                        _vm.$set(shift, "note", $$v)
                                      },
                                      expression: "shift.note",
                                    },
                                  }),
                                  _c("div", { staticClass: "shift-status" }, [
                                    _vm._v(
                                      "\n                  Trạng thái:\n                  "
                                    ),
                                    _c(
                                      "strong",
                                      { class: _vm.statusClass(shift.status) },
                                      [
                                        _c("i", {
                                          class: _vm.statusIcon(shift.status),
                                        }),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.statusLabel(shift.status)
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  shift.lateCheckinMinutes > 0 ||
                                  shift.earlyCheckoutMinutes > 0 ||
                                  shift.lateCheckoutMinutes > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "shift-late-info" },
                                        [
                                          shift.lateCheckinMinutes > 0
                                            ? _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "late-icon",
                                                    },
                                                    [_vm._v("⏰")]
                                                  ),
                                                  _c("strong", [
                                                    _vm._v("Đến muộn:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        shift.lateCheckinMinutes
                                                      ) +
                                                      " phút\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          shift.earlyCheckoutMinutes > 0
                                            ? _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "late-icon",
                                                    },
                                                    [_vm._v("🏃")]
                                                  ),
                                                  _c("strong", [
                                                    _vm._v("Về sớm:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        shift.earlyCheckoutMinutes
                                                      ) +
                                                      " phút\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          shift.lateCheckoutMinutes > 0
                                            ? _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "late-icon",
                                                    },
                                                    [_vm._v("🕐")]
                                                  ),
                                                  _c("strong", [
                                                    _vm._v("Về muộn:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        shift.lateCheckoutMinutes
                                                      ) +
                                                      " phút\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { "margin-top": "10px" },
                                          attrs: {
                                            type: "primary",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.historyAttendance(
                                                shift.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Lịch sử thay đổi\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      shift.id != null ? _c("el-divider") : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.updateAttendance
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        size: "medium",
                        loading: _vm.loadingButton,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("attendanceKid")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _vm._v(" Lưu\n    "),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogByButton()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _vm._v(" Đóng\n    "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("HistoryUpdateAttendanceDialog", {
            attrs: {
              recordId: _vm.recordId,
              showHistoryUpdateAttendance: _vm.showHistoryUpdateAttendance,
            },
            on: { "dialog-close": _vm.handleCloseHistoryUpdateAttendance },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }